import React from 'react';
import PropTypes from 'prop-types';
import {GroupingStyle, HeaderGroupingStyle} from './Table.styled';

const getVisibility = children => {
	let visible = false;
	React.Children.forEach(children, child => {
		visible = child.props.visible || visible;
	});
	return visible;
};

export const TableHeaderGrouping = React.memo(function TableHeaderGrouping({children, name, minWidth, ...props}) {
	if (getVisibility(children)) {
		return (
			<HeaderGroupingStyle minWidth={minWidth}>
				<div
					style={{
						width: '100%',
						textAlign: 'center',
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
					}}
				>
					{name}
				</div>
				<div style={{display: 'flex'}}>
					{React.Children.map(children, child => React.cloneElement(child, {usePadding: props.usePadding}))}
				</div>
			</HeaderGroupingStyle>
		);
	} else {
		return null;
	}
});

TableHeaderGrouping.propTypes = {
	children: PropTypes.any,
	usePadding: PropTypes.bool,
	name: PropTypes.string,
	minWidth: PropTypes.number,
};

export const TableGrouping = React.memo(function TableGrouping({children, lastGrouping, minWidth}) {
	if (getVisibility(children)) {
		return (
			<GroupingStyle lastGrouping={lastGrouping} minWidth={minWidth}>
				<div style={{display: 'flex', height: '100%'}}>{children}</div>
			</GroupingStyle>
		);
	} else {
		return null;
	}
});

TableGrouping.propTypes = {
	children: PropTypes.any,
	lastGrouping: PropTypes.bool,
	minWidth: PropTypes.number,
};
